import { Injectable } from '@angular/core';
import { IStepBackConfig, IAppSession } from '../../core/models/app.model';
import { EAPP_FLOWS } from '../../core/enums/app.enum';
import { APP_ROUTES as ROUTES } from '../../app.routes';
import { EFAST_ONBOARDING_STEPS, EONBOARDING_STEPS } from '../../core/enums/onboarding.enum';
import { ICustomerValidate } from '../../core/models/customer.model';
import {
  EVALIDATION_STATUS as STATUS,
  EVALIDATOR_COMPLETED,
  EVALIDATION_STATUS,
} from '../../core/enums/customer.enum';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor() {}

  public setStepBackConfig(newCurrentFlow, step, newOnboardingStep): IStepBackConfig {
    switch (newCurrentFlow) {
      case EAPP_FLOWS.AUTH:
        step = --step;
        return { newCurrentFlow, newStep: step, newOnboardingStep };

      case EAPP_FLOWS.ONBOARDING:
        step = step > EONBOARDING_STEPS.USER_INFO ? --step : step;
        return { newCurrentFlow, newStep: step };

      case EAPP_FLOWS.FAST_ONBOARDING:
        step = step > EONBOARDING_STEPS.USER_INFO ? --step : step;
        newOnboardingStep =
          newOnboardingStep > EFAST_ONBOARDING_STEPS.DNI_FORM
            ? --newOnboardingStep
            : newOnboardingStep;
        return { newCurrentFlow, newStep: step, newOnboardingStep: newOnboardingStep };

      case EAPP_FLOWS.PAYMENT:
        step = step > EONBOARDING_STEPS.USER_INFO ? --step : step;
        newCurrentFlow = step === EONBOARDING_STEPS.USER_INFO ? EAPP_FLOWS.SCORE : newCurrentFlow;
        return { newCurrentFlow, newStep: step };

      default:
        return { newCurrentFlow, newStep: step };
    }
  }
}
